// import {Injectable} from '@angular/core';
// import {Platform} from 'ionic-angular';
// import {MediaProvider} from '../media/media';
//
// import * as RecordRTC from 'recordrtc';
// import * as moment from 'moment';
// import {Observable, Subject} from 'rxjs';
// import {FileProvider} from '../file/file';
// import {ProofServerProvider} from "../proof-server/proof-server";
//
// interface RecordedAudioOutput {
//   blob: Blob;
//   title: string;
// }
//
// /*
//   Generated class for the ProofCameraProvider provider.
//
//   See https://angular.io/docs/ts/latest/guide/dependency-injection.html
//   for more info on providers and Angular DI.
// */
// @Injectable()
// export class ProofAudioProvider {
//
//
//   private proofId: number = null;
//   private stream;
//   private recorder;
//   private interval;
//   private startTime;
//   private _recorded = new Subject<RecordedAudioOutput>();
//   private _recordingTime = new Subject<string>();
//   private _recordingFailed = new Subject<string>();
//
//   constructor(
//     private platform: Platform,
//     private mediaProvider: MediaProvider,
//     private fileProvider: FileProvider,
//     private proofServer: ProofServerProvider,
//   ) {
//     console.log('Hello ProofAudioProvider Provider');
//   }
//
//   initiate(proofId: number, questionId: number, seconds: number, secondsRemaining: number) {
//     console.log('ProofAudioProvider - Initiate');
//     let that = this;
//     this.proofId = proofId;
//     this.platform.ready().then(() => {
//       that.takeAudio(questionId, seconds, secondsRemaining);
//       console.log("Cheguei no Initiate ")
//     });
//   }
//
//   takeAudio(questionId: number, seconds: number, secondsRemaining: number) {
//     console.log('ProofAudioProvider - Taking audio');
//     let that = this;
//     if (this.proofId) {
//       this.mediaProvider.takeAudio(questionId, seconds, secondsRemaining);
//     }
//
//   }
//
//
//   getRecordedBlob(): Observable<RecordedAudioOutput> {
//     return this._recorded.asObservable();
//   }
//
//   getRecordedTime(): Observable<string> {
//     return this._recordingTime.asObservable();
//   }
//
//   recordingFailed(): Observable<string> {
//     return this._recordingFailed.asObservable();
//   }
//
//
//   startRecording() {
//
//     this._recordingTime.next('00:00');
//     navigator.mediaDevices.getUserMedia({audio: true}).then(s => {
//       this.stream = s;
//       this.record();
//
//     }).catch(error => {
//       this._recordingFailed.next();
//     });
//
//   }
//
//   abortRecording() {
//     this.stopMedia();
//   }
//
//   private record() {
//
//     this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
//       type: 'audio',
//       mimeType: 'audio/webm'
//     });
//
//     this.recorder.record();
//     this.startTime = moment();
//     this.interval = setInterval(
//       () => {
//         const currentTime = moment();
//         const diffTime = moment.duration(currentTime.diff(this.startTime));
//         const time = this.toString(diffTime.minutes()) + ':' + this.toString(diffTime.seconds());
//         this._recordingTime.next(time);
//       },
//       1000
//     );
//   }
//
//   private toString(value) {
//     let val = value;
//     if (!value) {
//       val = '00';
//     }
//     if (value < 10) {
//       val = '0' + value;
//     }
//     return val;
//   }
//
//   stopRecording(questionId, kind, note, extra, captured, seconds, secondsRemaining) {
//
//     if (this.recorder) {
//       this.recorder.stop((blob) => {
//         if (this.startTime) {
//           const mp3Name = encodeURIComponent(this.fileProvider.generateName() + '.mp3');
//
//           this._recorded.next({blob: blob, title: mp3Name});
//           this.stopMedia();
//           this.proofServer.saveAudio(blob, mp3Name, questionId, kind, note, extra, captured, seconds, secondsRemaining);
//       }
//       }, () => {
//         this.stopMedia();
//         this._recordingFailed.next();
//       });
//     }
//   }
//
//   private stopMedia() {
//     if (this.recorder) {
//       this.recorder = null;
//       clearInterval(this.interval);
//       this.startTime = null;
//       if (this.stream) {
//         this.stream.getAudioTracks().forEach(track => track.stop());
//         this.stream = null;
//       }
//     }
//   }
//
//   destroy() {
//     console.log('ProofAudioProvider - Destroy');
//
//     this.proofId = null;
//     // this.audio.stopCamera().catch(() => { });
//   }
//
//
// }

import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { MediaProvider } from '../media/media';
import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { FileProvider } from '../file/file';
import { ProofServerProvider } from "../proof-server/proof-server";

interface RecordedAudioOutput {
  blob: Blob;
  title: string;
}

@Injectable()
export class ProofAudioProvider {
  private proofId: number = null;
  private stream: MediaStream;
  private recorder: any;
  private interval: any;
  private startTime: moment.Moment;
  private _recorded = new Subject<RecordedAudioOutput>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();

  constructor(
    private platform: Platform,
    private mediaProvider: MediaProvider,
    private fileProvider: FileProvider,
    private proofServer: ProofServerProvider
  ) {
    console.log('ProofAudioProvider initialized');
  }

  initiate(proofId: number, questionId: number, seconds: number, secondsRemaining: number) {
    this.proofId = proofId;
    this.platform.ready().then(() => {
      this.takeAudio(questionId, seconds, secondsRemaining);
      console.log('ProofAudioProvider - Initiated');
    });
  }

  takeAudio(questionId: number, seconds: number, secondsRemaining: number) {
    if (this.proofId) {
      this.mediaProvider.takeAudio(questionId, seconds, secondsRemaining);
    }
  }

  getRecordedBlob(): Observable<RecordedAudioOutput> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  startRecording() {
    this._recordingTime.next('00:00');
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.stream = stream;
      this.record();
    }).catch(() => {
      this._recordingFailed.next();
    });
  }

  abortRecording() {
    this.stopMedia();
  }

  private record() {
    this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
      type: 'audio',
      mimeType: 'audio/webm'
    });

    this.recorder.record();
    this.startTime = moment();

    this.interval = setInterval(() => {
      const diffTime = moment.duration(moment().diff(this.startTime));
      const formattedTime = `${this.formatTime(diffTime.minutes())}:${this.formatTime(diffTime.seconds())}`;
      this._recordingTime.next(formattedTime);
    }, 1000);
  }

  private formatTime(value: number): string {
    return value < 10 ? `0${value || 0}` : `${value}`;
  }

  stopRecording(
    questionId: number, kind: string, note: string, extra: string,
    captured: any, seconds: number, secondsRemaining: number
  ) {
    if (this.recorder) {
      this.recorder.stop((blob: Blob) => {
        if (this.startTime) {
          const mp3Name = `${encodeURIComponent(this.fileProvider.generateName())}.mp3`;
          this._recorded.next({ blob, title: mp3Name });
          this.stopMedia();
          this.proofServer.saveAudio(blob, mp3Name, questionId, kind, note, extra, captured, seconds, secondsRemaining);
        }
      }, () => {
        this.stopMedia();
        this._recordingFailed.next();
      });
    }
  }

  private stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      clearInterval(this.interval);
      this.startTime = null;
    }
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  destroy() {
    console.log('ProofAudioProvider - Destroyed');
    this.proofId = null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/proof-audio/proof-audio.ts